//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"Distance",0,"Expression",0],[0,"MeasureAlong",1,0],[0,"PointMethod",1,0],[1,"Reference",0,"SelectNXObject",0],[0,"SpecifyPoint",1,"Point",0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Features.ShipDesign.OrientationPointMethodsBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.OrientationPointMethodsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.OrientationPointMethodsBuilder.PointMethodTypes = Object.freeze({
    "ByPoint" : "ByPoint", "ByDistance" : "ByDistance", "FromStart" : "FromStart", "FromEnd" : "FromEnd"});

SPLM.Features.ShipDesign.OrientationPointMethodsBuilder.MeasureAlongTypes = Object.freeze({
    "Curve" : "Curve", "Axis" : "Axis"});

export default SPLM;